"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var empty_link_analytics_graphic_svg_1 = __importDefault(require("@assets/components/user/drawer/empty-link-analytics-graphic.svg"));
var react_i18next_1 = require("react-i18next");
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        emptyLinkAnalyticsGraphic: {
            marginTop: '24px',
            position: 'relative',
            zIndex: -1,
        },
        emptyLinkAnalyticsBodyText: {
            marginTop: '27px',
            textAlign: 'center',
            padding: '10px',
        },
    });
});
/**
 * @component Default display component in place of search result.
 */
var NoLinkAnalyticsGraphic = function () {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.emptyLinkAnalyticsGraphic },
            react_1.default.createElement("img", { width: "100%", src: empty_link_analytics_graphic_svg_1.default, alt: "empty link analytics graphic" })),
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyLinkAnalyticsBodyText }, t('editLink.analytics.notFound'))));
};
exports.default = NoLinkAnalyticsGraphic;
